import faceImage from '$src/assets/images/face.png'
import markkuLogo from '$src/assets/images/markku_fi.png'
import { ActionIcon, Group, Image, Indicator, rem } from '@mantine/core'
import { PlaceholderContent } from '@markku/components'
import { IconBell } from '@tabler/icons-react'
import styles from './Header.module.css'

interface HeaderProps {
  unreadNotifications: number
}

export function Header({ unreadNotifications }: HeaderProps) {
  return (
    <Group
      justify="space-between"
      align="center"
      wrap="nowrap"
      className={styles.header}
    >
      <Group gap="xs" wrap="nowrap">
        <Image
          src={faceImage}
          alt="Markku"
          style={{ width: rem(32), height: rem(32), objectFit: 'contain' }}
          fit="contain"
        />
        <Image
          src={markkuLogo}
          alt="Markku"
          style={{ height: rem(24), objectFit: 'contain' }}
          fit="contain"
        />
      </Group>

      <PlaceholderContent>
        <Indicator
          inline
          label={unreadNotifications}
          size={16}
          disabled={unreadNotifications === 0}
          color="brandOrange"
        >
          <ActionIcon
            variant="subtle"
            size="lg"
            radius="xl"
            aria-label="Ilmoitukset"
          >
            <IconBell size={24} />
          </ActionIcon>
        </Indicator>
      </PlaceholderContent>
    </Group>
  )
}
